import React from "react";
import { Wrapper, Image } from "./styled";
import ArrowBack from "../../../../images/arrowNext.png";

const ArrowNextIconMiniature = (props) => {
  return (
    <Wrapper onClick={props.onClick} disabled={props.disabled}>
      <Image src={ArrowBack} alt="icon" />
    </Wrapper>
  );
};

export default ArrowNextIconMiniature;
